<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-kemu-copy"></i>
      考场
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input
              v-model="org_name"
              placeholder="请输入考场名称"
              class="margin-right-xs"
          ></el-input>
          <el-input
              v-model="stu_num"
              placeholder="请输入报名人数"
              class="margin-right-xs"
          ></el-input>
          <el-select v-model="status" placeholder="请选择状态" class="margin-right-xs">
            <el-option label="承接" value="1"></el-option>
            <el-option label="待承接" value="0"></el-option>
            <el-option label="拒绝" value="-1"></el-option>
          </el-select>
          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>

        <el-button type="primary" @click="releaseDialog=true">
          <p class="flex align-center font-size">
            <i class="iconfont iconxinzeng margin-right-xs"></i>选择考场
          </p>
        </el-button>
      </div>
      <div class="table-warpper">
        <el-table
            :data="examList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column label="考场">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.org_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="联系人">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.username }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.phone }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="最大承接量">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_max }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="报名人数">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_num }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="承接状态">
            <template slot-scope="scope">
              <div class="table-item">
                <span v-if="scope.row.status === -1">拒绝</span>
                <span v-if="scope.row.status === 0">待承接</span>
                <span v-if="scope.row.status === 1">承接</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                    size="medium"
                    type="primary"
                    @click="editItem(scope.row.org_id)"
                >查看详情
                </el-button>
                <el-button
                    v-if="scope.row.status === 1"
                    size="medium"
                    type="primary"
                    @click="toStudent(scope.row.org_id)"
                >考生列表
                </el-button>

              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
    </div>
    <release-dialog
        :subdialogDialog="releaseDialog"
        @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import {checkRoomList, checkRoomDel} from "@/api/projectOffice";
import releaseDialog from "@/views/projectOffice/page/dialog/examCenterDialog";

export default {
  name: "examCenter",
  components: {releaseDialog},
  data() {
    return {
      org_name: "",
      stu_num: '',
      status: '',
      examList: [],
      releaseDialog: false
    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/projectOffice/examination',
        "当前位置：考试管理 > 考场",
        true
    );
    this.getList();
  },
  methods: {
    async getList() {
      let _list = await checkRoomList(this.$route.query.id, this.org_name, this.stu_num, this.status);
      this.examList = _list.data
    },

    editItem(id) {
      this.$router.push('/projectOffice/organizationDetail4?id=' + id)
    },

    deleteItem(id) {
      this.$confirm("确定要删除该考场吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await checkRoomDel(id);
      this.getList();
      this.$message.success(_state.msg);
    },
    toStudent(id){
      this.$router.push('/projectOffice/examStudent?id=' + id +'&examId=' + this.$route.query.id)
    },
    onSearch() {
      this.getList();
    },

    cancelDialog(val) {
      this.releaseDialog = false
      this.getList()
    }


  }
}
</script>

<style scoped lang="scss">
.status-box {
  position: relative;

  .status-click {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>